import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import NotInterestedIcon from "@mui/icons-material/NotInterested";

const ConvoBrick = (props) => {
  const { response } = props;

  return (
    <ListItem sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
      <ListItemIcon sx={{ minWidth: 36 }}>
        <NotInterestedIcon color="error" fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={response.Answer.error} slotProps={{ primary: { color: "error", variant: "body2" } }} />
    </ListItem>
  );
};

export default ConvoBrick;
